import { Space, Card, Row, Col } from 'antd';
import { useFormikContext } from 'formik';
import { get } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import {
    type CheckboxConsentsAndDeclarationsSettings,
    type MarketingConsentsAndDeclarationsSettings,
    ModuleType,
    type TextConsentsAndDeclarationsSettings,
} from '../../../api/types';
import ModuleSelectField from '../../../components/fields/ModuleSelectField';
import SelectField from '../../../components/fields/SelectField';
import useConsentTypeOptions from '../../../utilities/useConsentTypeOptions';
import ConsentsAndDeclarationsDetails from '../ConsentsAndDeclarationsDetailsPage/ConsentsAndDeclarationsDetails';

type ConsentSettingTypes =
    | TextConsentsAndDeclarationsSettings
    | CheckboxConsentsAndDeclarationsSettings
    | MarketingConsentsAndDeclarationsSettings;

export type AddConsentsAndDeclarationsPageProps = {
    initialValues: ConsentSettingTypes;
};

const AddConsentsAndDeclarationsPage = ({ initialValues }: AddConsentsAndDeclarationsPageProps) => {
    const { t } = useTranslation(['consentsAndDeclarations']);
    const { values } = useFormikContext();
    const consentTypeOptions = useConsentTypeOptions();

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <Card title={t('consentsAndDeclarations:cardTitles.selectModule')}>
                <Row gutter={14}>
                    <Col lg={8} xs={24}>
                        <ModuleSelectField
                            {...t('consentsAndDeclarations:fields.module', { returnObjects: true })}
                            moduleType={ModuleType.ConsentsAndDeclarations}
                            name="moduleId"
                            required
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <SelectField
                            {...t('consentsAndDeclarations:fields.consentType', { returnObjects: true })}
                            name="consentType"
                            options={consentTypeOptions}
                            required
                            showSearch
                        />
                    </Col>
                </Row>
            </Card>
            <ConsentsAndDeclarationsDetails initialValues={initialValues} type={get('consentType', values)} />
        </Space>
    );
};

export default AddConsentsAndDeclarationsPage;
